var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-layout-fixer"},[_c('iframe',{staticClass:"player-iframe",attrs:{"id":"iframe","src":_vm.playerIframeUrl,"frameborder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }